import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { IRouterParams } from '../pages/explore-expenses'
import { exploreIncomesQueryState } from '../recoil'

export default () => {
	const params = useParams<IRouterParams>()
	const [query, setQuery] = useRecoilState(exploreIncomesQueryState)
	useEffect(() => {
		setQuery((currentValue) => ({
			...currentValue,
			match: {
				...params,
				year: params.year ? parseInt(params.year) : undefined,
				quarter: params.quarter ? parseInt(params.quarter) : undefined,
			},
		}))
	}, [params, setQuery])

	return query
}
